import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as DashboardActions from './dashboard.actions';
import { DashboardService } from '../data-access/dashboard.service';
import {
  loadDashboardStatistics,
  loadDashboardStatisticsFailure,
  loadDashboardStatisticsSuccess
} from "./dashboard.actions";

@Injectable()
export class DashboardEffects {
  loadRecentActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadRecentActivity),
      switchMap(() =>
        this.dashboardService.getRecentActivity().pipe(
          map((recentActivity) =>
            DashboardActions.loadRecentActivitySuccess({ recentActivity })
          ),
          catchError((error) =>
            of(DashboardActions.loadRecentActivityFailure({ error }))
          )
        )
      )
    )
  );

  loadDashboardStatistics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDashboardStatistics),
      switchMap((x) =>
        this.dashboardService.getDashboardStatistics(x.filterItem).pipe(
          map((dashboardStatistics) =>
            loadDashboardStatisticsSuccess({ dashboardStatistics })
          ),
          catchError((error) =>
            of(loadDashboardStatisticsFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService
  ) {}
}
